/**
 * Returns the Barbados states list to populate the select item.
 */
 export function gluky_addressfield_lc_states_list() {
  let temporalStates = [];
  const states =
  {
    '01': 'Anse la Raye',
    '02': 'Canaries',
    '03': 'Castries',
    '04': 'Choiseul',
    '05': 'Dennery',
    '06': 'Gros Islet',
    '07': 'Laborie',
    '08': 'Micoud',
    '09': 'Soufrière',
    '10': 'Vieux Fort'
  }
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Barbados cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_lc_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '01': {
        '0101': 'Anse la Raye',
        '0102': 'Anse La verdune',
        '0103': 'Anse La verdure',
        '0104': 'Au Tabor',
        '0105': 'Bois dInde',
        '0106': 'Dame de Traversay',
        '0107': 'Derriere Lagoon',
        '0108': 'Jacmel',
        '0109': 'Perou',
        '0110': 'Roseau',
        '0111': 'Theodorine',
    },
    '02': {
        '0201': 'Canaries',
    },
    '03': {
        '0301': 'Almondale',
        '0302': 'Belair',
        '0303': 'Bexon',
        '0304': 'Bisee',
        '0305': 'Cabiche',
        '0306': 'Castries City',
        '0307': 'Castries City, Grass Street Area',
        '0308': 'Castries City, Marchand Area',
        '0309': 'Charlotte',
        '0310': 'Ciceron',
        '0311': 'Conway',
        '0312': 'Crown Lands',
        '0313': 'Damme Travesay',
        '0314': 'Deglos',
        '0315': 'Derriere Lagoon',
        '0316': 'Ferrand',
        '0317': 'Floissac',
        '0318': 'Forestiere',
        '0319': 'Forestierre',
        '0320': 'Girard Cocoa',
        '0321': 'Good Lands',
        '0322': 'Incommode',
        '0323': 'Jacmel',
        '0324': 'L Abbayee',
        '0325': 'La Raye',
        '0326': 'Marc marc',
        '0327': 'Perou',
        '0328': 'Point Seraphine',
        '0329': 'Ravine Posion',
        '0330': 'Roseau',
        '0331': 'Sancouci',
        '0332': 'Soucis',
        '0333': 'Vigie',
    },
    '04': {
        '0401': 'Belle Plaine',
        '0402': 'Cafeire',
        '0403': 'Choiseul',
        '0404': 'Durlgard',
        '0405': 'L Ivrogne',
        '0406': 'La Fargue',
        '0407': 'La Pointe',
        '0408': 'La Riche',
        '0409': 'Mondesir',
        '0410': 'Union Vale',
    },
    '05': {
        '0501': 'Anse Canot',
        '0502': 'Aux Leon',
        '0503': 'Blemont',
        '0504': 'Bosquet DOr',
        '0505': 'Deliade',
        '0506': 'Dennery',
        '0507': 'Derniere Riverie',
        '0508': 'Frigate Island Nature Reserve',
        '0509': 'La Cave',
        '0510': 'La Pelle',
        '0511': 'La Ressource',
        '0512': 'Mon Repos',
        '0513': 'Morne Panache',
        '0514': 'Praslin',
        '0515': 'Violon Point'
    },
    '06': {
        '0601': 'Baboneau',
        '0602': 'Balata',
        '0603': 'Beausejour Phase 1',
        '0604': 'Beausejour Phase 2',
        '0605': 'Cap Estate',
        '0606': 'Castries Waterforks Forest Reserve',
        '0607': 'Corinth',
        '0608': 'Dauphin Beach',
        '0609': 'Degazon',
        '0610': 'Fond Assau',
        '0611': 'Fort Rodney',
        '0612': 'Garrand',
        '0613': 'Grand Anse Beach',
        '0614': 'Grande Riviere',
        '0615': 'Gros Islet',
        '0616': 'La Bourne',
        '0617': 'La Feuillet',
        '0618': 'Marquis',
        '0619': 'Marquis Bay',
        '0620': 'Monchy',
        '0621': 'Mongiraud',
        '0622': 'Morne Serpent',
        '0623': 'Plantation Beach',
        '0624': 'Plateau',
        '0625': 'Reduit Beach',
        '0626': 'Rodney Bay',
    },
    '07': {
        '0701': 'Banse',
        '0702': 'Debreil',
        '0703': 'La Haut',
        '0704': 'Laborie',
        '0705': 'Londonderry',
        '0706': 'Mondesir',
        '0707': 'Saltibus',
        '0708': 'Sapphire',
    },
    '08': {
        '0801': 'Anbre',
        '0802': 'Blanchard',
        '0803': 'Desruisseaux',
        '0804': 'Hellene',
        '0805': 'La Cour Ville',
        '0806': 'Micoud',
        '0807': 'Quilesse Forest Reserve',
        '0808': 'Rouame',
        '0809': 'Savannes',
    },
    '09': {
        '0901': 'Anse Chastanet',
        '0902': 'Belle Vue',
        '0903': 'Belvedere',
        '0904': 'Bouton',
        '0905': 'Fond Doux',
        '0906': 'Mahaut',
        '0907': 'Malgretoute',
        '0908': 'Mamin',
        '0909': 'Migny',
        '0910': 'Palmiste',
        '0911': 'Soufrière',
        '0912': 'Soufrière Bay',
        '0913': 'Soufrière Town Square',
        '0914': 'The Pitons',
    },
    '10': {
        '1001': 'Banse',
        '1002': 'Belle Vue',
        '1003': 'Black Bay',
        '1004': 'Derriere Morne',
        '1005': 'Eau Picant',
        '1006': 'Edmund Forest Reserve',
        '1007': 'Grace',
        '1008': 'La Resource',
        '1009': 'La Retraite',
        '1010': 'La Tourney',
        '1011': 'Maria Islands Nature Reserve',
        '1012': 'Morne Cailandre',
        '1013': 'Pierrot',
        '1014': 'Pointe Sable',
        '1015': 'Pointe Sable',
        '1016': 'St. Urbain',
        '1017': 'Vieux Fort',
        '1018': 'Vieux Fort bay',
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

